import { ModalityOption } from '@datasets/Modality';

export const getModalityValues = (
    modality: string,
    programModalityReasons: ModalityOption[],
) =>
    (programModalityReasons.find(({ ID }) => ID === modality) as ModalityOption)
        ?.value;
export default getModalityValues;
